import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { detailSearchParams } from '@@components/Page/detailSearchParams';
import { loadContentDetail } from '@@components/Page/loadContentDetail';
import { placementHistorySearchParams } from '@@containers/placementHistory/placementHistorySearchParams';

import { ArticleDetailPage } from '../-components/ArticleDetailPage';

export const Route = createFileRoute('/_authenticated/articles/$id')({
    // Articles have no read-only mode, so they have no isEditingContent
    validateSearch: detailSearchParams
        .pick({ history: true })
        .extend(placementHistorySearchParams.shape),
    context: ({ params }) => ({
        contentQuery: client.content.article.get.queryOptions({ params: { id: params.id } }),
    }),
    loader: ({ abortController, context, params }) =>
        loadContentDetail({ ...context, abortController }, params.id),
    component: ArticleDetailPage,
});
